import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"facebook\"><path d=\"M13.86 24V13.05h3.67l.55-4.26h-4.22V6.06C13.86 4.83 14.2 4 16 4h2.26V.17A30.51 30.51 0 0014.94 0c-3.26 0-5.49 2-5.49 5.64v3.15H5.77v4.26h3.68V24z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol